import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useSetAtom } from "jotai";

import { ModalRoot } from "components/Modal";

import { apiGet } from "services/api";

import { LeftNavBar } from "features/LeftNavBar";

import { settingsAtom } from "atoms/settingsAtom";

const useInit = () => {
  const setSettings = useSetAtom(settingsAtom);

  useEffect(() => {
    apiGet("settings")
      .then((settings) => {
        if (settings && settings.settingsid) setSettings(settings);
      })
      .catch(() => {});
  }, [setSettings]);
};

export const App = () => {
  useInit();

  return (
    <>
      <div className="flex main-background-color main_wrapper">
        <LeftNavBar />
        <Outlet />
      </div>
      <ModalRoot />
    </>
  );
};
